"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_CART_ELEC_GAS_MOBILE_NBN = exports.MOCK_CART_ELEC_GAS_MOBILE = exports.MOCK_CART_INVALID = exports.MOCK_CART_MOBILE_NBN = exports.MOCK_CART_MOBILE = exports.MOCK_CART_NBN_VOIP_PORT = exports.MOCK_CART_NBN_VOIP_NEW = exports.MOCK_CART_ELEC_GAS_CARBON_NEUTRAL = exports.MOCK_CART_NBN_ELEC_GAS = exports.MOCK_CART_GAS_ELEC = exports.MOCK_CART_NBN = exports.MOCK_CART_ELEC_GAS_NBN = exports.MOCK_CART_ELEC_GAS = exports.MOCK_CART_GAS = exports.MOCK_CART_ELEC = exports.MOCK_CART_QUOTE_ID = exports.MOCK_CART_ID = void 0;
const cart_item_elec_mock_1 = require("./cart-item-elec.mock");
const cart_item_mobile_mock_1 = require("./cart-item-mobile.mock");
const cart_item_modem_mock_1 = require("./cart-item-modem.mock");
const cart_item_nbn_mock_1 = require("./cart-item-nbn.mock");
const cart_item_voip_mock_1 = require("./cart-item-voip.mock");
const cart_item_carbon_neutral_elec_mock_1 = require("./cart-item.carbon-neutral-elec.mock");
const cart_item_carbon_neutral_gas_mock_1 = require("./cart-item.carbon-neutral-gas.mock");
const cart_item_gas_mock_1 = require("./cart-item.gas.mock");
const cart_item_invalid_mock_1 = require("./cart-item-invalid.mock");
exports.MOCK_CART_ID = 'PXTJSj9ckjvidnWsZ8GBqZuhD0vCVdTL';
exports.MOCK_CART_QUOTE_ID = 12345;
exports.MOCK_CART_ELEC = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_elec_mock_1.MOCK_CART_ITEM_ELECTRICITY],
};
exports.MOCK_CART_GAS = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_gas_mock_1.MOCK_CART_ITEM_GAS],
};
exports.MOCK_CART_ELEC_GAS = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_elec_mock_1.MOCK_CART_ITEM_ELECTRICITY, cart_item_gas_mock_1.MOCK_CART_ITEM_GAS],
};
exports.MOCK_CART_ELEC_GAS_NBN = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_elec_mock_1.MOCK_CART_ITEM_ELECTRICITY, cart_item_gas_mock_1.MOCK_CART_ITEM_GAS, cart_item_nbn_mock_1.MOCK_CART_ITEM_NBN],
};
exports.MOCK_CART_NBN = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_nbn_mock_1.MOCK_CART_ITEM_NBN],
};
exports.MOCK_CART_GAS_ELEC = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_gas_mock_1.MOCK_CART_ITEM_GAS, cart_item_elec_mock_1.MOCK_CART_ITEM_ELECTRICITY],
};
exports.MOCK_CART_NBN_ELEC_GAS = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_nbn_mock_1.MOCK_CART_ITEM_NBN, cart_item_elec_mock_1.MOCK_CART_ITEM_ELECTRICITY, cart_item_gas_mock_1.MOCK_CART_ITEM_GAS],
};
exports.MOCK_CART_ELEC_GAS_CARBON_NEUTRAL = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [
        cart_item_elec_mock_1.MOCK_CART_ITEM_ELECTRICITY,
        cart_item_carbon_neutral_elec_mock_1.MOCK_CART_ITEM_CARBON_NEUTRAL_ELECTRICITY,
        cart_item_gas_mock_1.MOCK_CART_ITEM_GAS,
        cart_item_carbon_neutral_gas_mock_1.MOCK_CART_ITEM_CARBON_NEUTRAL_GAS
    ],
};
exports.MOCK_CART_NBN_VOIP_NEW = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_nbn_mock_1.MOCK_CART_ITEM_NBN, cart_item_voip_mock_1.MOCK_CART_ITEM_VOIP_NEW, cart_item_modem_mock_1.MOCK_CART_ITEM_MODEM],
};
exports.MOCK_CART_NBN_VOIP_PORT = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_nbn_mock_1.MOCK_CART_ITEM_NBN, cart_item_voip_mock_1.MOCK_CART_ITEM_VOIP_PORT, cart_item_modem_mock_1.MOCK_CART_ITEM_MODEM],
};
exports.MOCK_CART_MOBILE = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_mobile_mock_1.MOCK_CART_ITEM_MOBILE],
};
exports.MOCK_CART_MOBILE_NBN = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_mobile_mock_1.MOCK_CART_ITEM_MOBILE, cart_item_nbn_mock_1.MOCK_CART_ITEM_NBN],
};
exports.MOCK_CART_INVALID = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_invalid_mock_1.MOCK_CART_ITEM_INVALID],
};
exports.MOCK_CART_ELEC_GAS_MOBILE = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_elec_mock_1.MOCK_CART_ITEM_ELECTRICITY, cart_item_gas_mock_1.MOCK_CART_ITEM_GAS, cart_item_mobile_mock_1.MOCK_CART_ITEM_MOBILE],
};
exports.MOCK_CART_ELEC_GAS_MOBILE_NBN = {
    cartId: exports.MOCK_CART_ID,
    cartItems: [cart_item_elec_mock_1.MOCK_CART_ITEM_ELECTRICITY, cart_item_gas_mock_1.MOCK_CART_ITEM_GAS, cart_item_mobile_mock_1.MOCK_CART_ITEM_MOBILE, cart_item_nbn_mock_1.MOCK_CART_ITEM_NBN],
};
//# sourceMappingURL=cart.mock.js.map